import { StoreonModule } from "storeon"

export interface INavigationStore {
  navigationStore: {
    isNavDisabled: boolean,
    onContinue: () => void,
  };
};

export interface INavigationEvents {
  setIsNavDisabled: boolean;
  setOnContinue: () => void;
};

const navigationStore: StoreonModule<INavigationStore, INavigationEvents>= (store) => {
  store.on('@init', () => ({
    navigationStore: {
      isNavDisabled: false,
      onContinue: () => {},
    }
  }))

  store.on('setIsNavDisabled', ({navigationStore}, event) => {
    navigationStore.isNavDisabled = event;
    return {navigationStore};
  })

  store.on('setOnContinue', ({navigationStore}, event) => {
    navigationStore.onContinue = event;
    return {navigationStore};
  })
}

export default navigationStore;